// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsLinks_RefundInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payments/links/refund/{id}
 *
 * Refunds ALL charges for a payment link (DEPRECATED).
 * Use refund_recebimento() for granular control instead.
 */
import { registerContract } from './validate'

export interface SubaccountsLinks_RefundInput {
value?: number
}

registerContract('SubaccountsLinks_RefundInput', {
  value: { type: 'number',  required: false },
})
